<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Panel Trim';
                }
            },
            component_id: {
                default(){
                    return 'panel_trim';
                }
            },
            slab: {
                required: true
            },
            maintitle: {
                default() {
                    return 'Select Panel Trim';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/panel-trim?slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.slab;
            },
            panel_required(){
                return this.filtered_option_list.length > 0
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
